import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

var routes = [
  {
    path: '/login',
    name: 'Login',
    component: function() { return import('../views/Login.vue') },
    meta: { title: '管理员登录', noAuth: true }
  },
  {
    path: '/',
    component: function() { return import('../views/Layout.vue') },
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: function() { return import('../views/dashboard/Index.vue') },
        meta: { title: '数据总览', icon: 'el-icon-data-analysis' }
      },
      {
        path: 'user',
        name: 'User',
        component: function() { return import('../views/user/Index.vue') },
        meta: { title: '用户管理', icon: 'el-icon-user' }
      },
      {
        path: 'order',
        name: 'Order',
        component: function() { return import('../views/order/Index.vue') },
        meta: { title: '订单管理', icon: 'el-icon-shopping-cart-2' }
      },
      {
        path: 'product',
        name: 'Product',
        component: function() { return import('../views/product/Index.vue') },
        meta: { title: '产品管理', icon: 'el-icon-goods' }
      },
      {
        path: 'points',
        name: 'Points',
        component: function() { return import('../views/points/Index.vue') },
        meta: { title: '积分记录', icon: 'el-icon-coin' }
      },
      {
        path: 'balance',
        name: 'Balance',
        component: function() { return import('../views/balance/Index.vue') },
        meta: { title: '余额提现', icon: 'el-icon-wallet' }
      },
      {
        path: 'goldcoin',
        name: 'GoldCoin',
        component: function() { return import('../views/goldcoin/Index.vue') },
        meta: { title: '金币商城', icon: 'el-icon-star-on' }
      },
      {
        path: 'service-center',
        name: 'ServiceCenter',
        component: function() { return import('../views/serviceCenter/Index.vue') },
        meta: { title: '服务中心', icon: 'el-icon-office-building' }
      },
      {
        path: 'version',
        name: 'Version',
        component: function() { return import('../views/version/Index.vue') },
        meta: { title: '版本管理', icon: 'el-icon-mobile-phone' }
      }
    ]
  }
]

var router = new VueRouter({
  routes: routes
})

// 路由守卫：未登录跳登录页
router.beforeEach(function(to, from, next) {
  if (to.meta.noAuth) {
    next()
  } else {
    if (store.getters.isLoggedIn) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router